import React, { FormEvent } from 'react';
import { NumericFormat, PatternFormat } from 'react-number-format';
import clsx from 'clsx';
import { useController } from 'react-hook-form';

export const NumberInput = ({
  containerClass,
  rounded = 'rounded-md',
  startIcon,
  endIcon,
  name,
  defaultValue,
  control,
  thousandSeparator = ',',
  className,
  placeholder,
  displayType = 'input',
  handleChange,
  ...props
}: any) => {
  const {
    field: { ref, ...fields },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: defaultValue || '',
  });

  const onChange = (e: FormEvent<HTMLInputElement>, fields: any) => {
    fields.onChange(e.currentTarget.value);
    handleChange?.(e.currentTarget.value, e.currentTarget.name);
  };
  return (
    <div className="max-h-[45px]">
      <div
        className={clsx(
          'flex items-center gap-x-3 rounded-md border border-stone-300 bg-white md:py-1',
          displayType !== 'text' && 'border',
          containerClass,
          rounded,
          startIcon ? 'px-4' : 'px-2'
        )}
      >
        {startIcon ? startIcon : null}
        <NumericFormat
          {...fields}
          {...props}
          // decimalScale={0}
          onChange={(e) => onChange(e, fields)}
          name={name}
          placeholder={placeholder}
          className={clsx(
            'dark:bg-brand-dark-200 w-full bg-white px-1 py-1 outline-none',
            className
          )}
          thousandSeparator={thousandSeparator}
        />
        {endIcon ? endIcon : null}
      </div>
      {error && displayType !== 'text' && (
        <small className="text-[10px] text-red-500">{error?.message}</small>
      )}
    </div>
  );
};

export const PatternInput = ({
  containerClass,
  rounded = 'rounded-md',
  startIcon,
  endIcon,
  name,
  defaultValue,
  control,
  className,
  placeholder,
  format = '',
  mask = '_',
  displayType = 'input',
  handleChange,
  ...props
}: any) => {
  const {
    field: { ref, ...fields },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: defaultValue || '',
  });

  const onChange = (e: FormEvent<HTMLInputElement>, fields: any) => {
    fields.onChange(e.currentTarget.value);
    handleChange?.(e.currentTarget.value, e.currentTarget.name);
  };
  return (
    <div className="max-h-[45px]">
      <div
        className={clsx(
          'brand-border-light brand-shadow focus-within:border-brand-blue dark:bg-brand-dark-200 flex items-center gap-x-3 bg-white py-1 md:py-0',
          displayType !== 'text' && 'border',
          containerClass,
          rounded,
          startIcon ? 'px-4' : 'px-2'
        )}
      >
        {startIcon ? startIcon : null}
        <PatternFormat
          {...fields}
          {...props}
          onChange={(e) => onChange(e, fields)}
          name={name}
          placeholder={placeholder}
          className={clsx(
            'dark:bg-brand-dark-200 w-full bg-white px-1 py-1 outline-none md:py-2',
            className
          )}
          format={format}
          mask={mask}
        />
        {endIcon ? endIcon : null}
      </div>
      {error && displayType !== 'text' && (
        <small className="text-[10px] text-red-500">{error?.message}</small>
      )}
    </div>
  );
};
